<template>
  <header :data-date="'You are printing a partial view of the Mississauga Interactive Zoning By-law 0225-2007 on ' + printDate() 
  + ' based on your selection(s). This information is provided for convenience purposes only as it may not reflect recently approved amendments. To view the entire Interactive Zoning By-law, visit www.mississauga.ca/zoningbylaw'">
    <div class="container-fluid">
      <div class="row header-title">
        <div class="container-fluid">
          <div class="row mx-2">
            <div class="col-12">
              <div class="header-logo">
                <a href="https://www.mississauga.ca/">
                  <span class="sr-only">City of Mississauga Homepage</span>
                  <SiteLogo />
                </a>
                <span v-if="is_live" class="xxxsmall-font warning">{{is_live}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import "@/assets/sass/header.scss";

import SiteLogo from "@/components/Svg/SiteLogo";
export default {
  name: "HeaderLayout",
  components: {
    SiteLogo
  },
  computed:{
     is_live(){
      return process.env.VUE_APP_ENV;
    }
  },
   methods: {
    printDate(){
      var currentDate = new Date();
      return currentDate.toLocaleString();
    }
   }
};
</script>